import { Component, computed, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { EngagementType } from '@interfaces';
import { CommonEngagementGridPart } from '../../../../../ui/widget';
import { ExperienceEngagementsService, } from '../../experience-engagements.service';

@Component({
	selector: 'experience-open-engagements-view-part',
	standalone: true,
	imports: [CommonEngagementGridPart],
	templateUrl: './open-engagements-view.part.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./open-engagements-view.part.scss'],
})
export class ExperienceEngagementsOpenEngagementsViewPart implements OnInit {
	public readonly pageService = inject(ExperienceEngagementsService);
	public engagements = computed(() => (this.pageService.engagements() || []).filter(t => !t.closedUTC));

	ngOnInit() {
		this.pageService.engagementType.set(EngagementType.open);
	}
}